import { ThemeColorValues, ThemeSizeValues } from './types/values.js';
import { useThemeVariable } from '../util/useThemeVariable.js';

/**
 * Converts strings with the name of a theme color to a CSS variable literal
 * (e.g. 'color-danger-500' to 'var(--color-danger-500)').
 * Strings not matching a theme color are returned unchanged (e.g. '#000000').
 */
function themeColorToCssVariable(color) {
  if (color && ThemeColorValues.includes(color)) {
    return `var(--${color})`;
  }
  return color;
}

/**
 * Converts strings with the name of a theme size to a CSS variable literal
 * (e.g. 'size-500' to 'var(--size-500)').
 * Strings not matching a theme size are returned unchanged (e.g. '1rem').
 */
function themeSizeToCssVariable(size) {
  if (size && ThemeSizeValues.includes(size)) {
    return `var(--${size})`;
  }
  return size;
}

/**
 * Converts strings with the name of a theme border radius to a CSS variable literal
 * (e.g. 'border-radius-default' to 'var(--border-radius-default)').
 * Strings not matching a theme border radius are returned unchanged (e.g. '1rem').
 */
function themeBorderRadiusToCssVariable(borderRadius) {
  if (borderRadius && (borderRadius === 'border-radius-default' || borderRadius === 'border-radius-full')) {
    return `var(--${borderRadius})`;
  }
  return borderRadius;
}

/** Given a base color and a weight, provides the value of that color weight.  */
function useColorWeight(name, weight, ref) {
  const parts = name.split('-');
  const colorName = parts[1];
  const isStatic = parts.includes('static');
  const newParts = isStatic ? ['color', colorName, weight.toString(), 'static'] : ['color', colorName, weight.toString()];
  const newName = newParts.join('-');
  return useThemeVariable(newName, ref);
}

export { themeBorderRadiusToCssVariable, themeColorToCssVariable, themeSizeToCssVariable, useColorWeight };
